import React from 'react';
import { CtaSecondary } from 'roh-frontend/packages/roh-react';
import { useHistory } from 'react-router-dom';
import Styled from './styled';
import { IProps } from './types';

const ErrorBlockComponent = ({ children }: IProps): React.ReactElement => {
  const history = useHistory();
  return (
    <>
      <Styled.Info>{children}</Styled.Info>
      <CtaSecondary
        type='button'
        text='Go back'
        icon={null}
        onClick={() => history.goBack()}
      />
    </>
  );
};

export default ErrorBlockComponent;
